// actionTypes.js
export const FETCH_FEEDBACKS_REQUEST = 'FETCH_FEEDBACKS_REQUEST'
export const FETCH_FEEDBACKS_SUCCESS = 'FETCH_FEEDBACKS_SUCCESS'
export const FETCH_FEEDBACKS_FAILURE = 'FETCH_FEEDBACKS_FAILURE'
